import React, { useEffect, useRef, useState } from "react";

export const latexToLogic = (latex) => {
  return latex
    .replaceAll("\\cdot", "*")
    .replaceAll("\\times", "*")
    .replaceAll("\\div", "/")
    .replaceAll("\\left(", "(")
    .replaceAll("\\right)", ")")
    .replace(/\\frac\{([^}]+)\}\{([^}]+)\}/g, "($1)/($2)")
    .replace(/\^{([^}]+)}/g, "**($1)")
    .replace(/\^([0-9])/g, "**$1")
    .replace(/\\sqrt\{([^}]+)\}/g, "Math.sqrt($1)")
    .replaceAll("{", "")
    .replaceAll("}", "")
    .replaceAll("\\", "")
    .trim();
};

export const latexToDisplay = (latex) => {
  return latex
    .replace(/\\frac\{([^}]+)\}\{([^}]+)\}/g, "($1)/($2)")
    .replace(/\^{([^}]+)}/g, "^($1)")
    .replaceAll("\\cdot", "×")
    .replaceAll("\\times", "×")
    .replaceAll("\\left(", "(")
    .replaceAll("\\right)", ")")
    .replaceAll("{", "")
    .replaceAll("}", "")
    .replaceAll("\\", "")
    .trim();
};

export default function MathInput({ onChange, placeholder }) {
  const mfRef = useRef(null);
  const [ready, setReady] = useState(false);

  // Poll until math-field custom element is defined
  useEffect(() => {
    let interval = setInterval(() => {
      if (window.customElements && window.customElements.get("math-field")) {
        setReady(true);
        clearInterval(interval);
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!ready || !mfRef.current) return;
    const mf = mfRef.current;
    const handler = () => onChange(mf.value);
    mf.addEventListener("input", handler);
    return () => mf.removeEventListener("input", handler);
  }, [ready]);

  if (!ready) return (
    <div style={{ border: "2px solid #dde3f0", borderRadius: 8, padding: "12px", color: "#aaa", fontSize: "0.9rem" }}>
      Loading math editor...
    </div>
  );

  return (
    <math-field
      ref={mfRef}
      style={{ width: "100%", fontSize: "1.1rem", border: "2px solid #dde3f0", borderRadius: "8px", padding: "8px 12px", display: "block" }}
    >
      {placeholder || ""}
    </math-field>
  );
}
